<div class="inner" *ngIf="!isApiLoading; else loading">
  <div class="title">
    <img src="assets/cat-icon.svg" alt="icon" />
    {{ detailData?.catName }}
  </div>
  <div class="img-list">
    <div
      class="image-box"
      *ngFor="let item of detailData?.fileList; let index = index"
      (click)="clickImage(item)"
    >
      <img
        class="image"
        [src]="item.path"
        [alt]="detailData?.catName + '_' + index"
      />
    </div>
  </div>
  <div class="info">
    <img src="assets/note.svg" alt="icon" class="icon" />
    <p>
      {{ detailData?.catContent }}
    </p>
  </div>
  <div class="btn-box">
    <div class="btn" (click)="goBack()">回上一頁</div>
  </div>
</div>
<ng-template #loading>
  <app-loading [isLoading]="isApiLoading"></app-loading>
</ng-template>
